import * as C from '../constants';

export default {
  [C.GIFT_VOUCHER_SEARCH_BRANDS_WITH_DOMAINS_PENDING](state) {
    state.search = {
      ...state.search,
      loading: true,
      error: false,
    };
  },
  [C.GIFT_VOUCHER_SEARCH_BRANDS_WITH_DOMAINS_SUCCESS](state, payload) {
    state.search = {
      ...state.search,
      loading: false,
      error: false,
      brands: {
        items: payload,
      },
    };
  },
  [C.GIFT_VOUCHER_SEARCH_BRANDS_WITH_DOMAINS_FAILURE](state) {
    state.search = {
      ...state.search,
      loading: false,
      error: true,
    };
  },
  [C.GIFT_VOUCHER_SEARCH_GIFT_VOUCHERS_PENDING](state) {
    state.search = {
      ...state.search,
      loading: true,
      error: false,
    };
  },
  [C.GIFT_VOUCHER_SEARCH_GIFT_VOUCHERS_NOCONTENT](state) {
    state.search = {
      ...state.search,
      loading: false,
      error: false,
      giftVouchers: {
        items: [],
      },
    };
  },
  [C.GIFT_VOUCHER_SEARCH_GIFT_VOUCHERS_SUCCESS](state, payload) {
    state.search = {
      ...state.search,
      loading: false,
      error: false,
      giftVouchers: {
        items: payload,
      },
    };
  },
  [C.GIFT_VOUCHER_SEARCH_GIFT_VOUCHERS_FAILURE](state) {
    state.search = {
      ...state.search,
      loading: false,
      error: true,
    };
  },
  [C.GIFT_VOUCHER_SEARCH_GIFT_VOUCHERS_REFERENCE_PENDING](state) {
    state.search = {
      ...state.search,
      loading: true,
      error: false,
    };
  },
  [C.GIFT_VOUCHER_SEARCH_GIFT_VOUCHERS_REFERENCE_NOTFOUND](state) {
    state.search = {
      ...state.search,
      loading: false,
      error: false,
      giftVouchers: {
        items: [],
      },
    };
  },
  [C.GIFT_VOUCHER_SEARCH_GIFT_VOUCHERS_REFERENCE_SUCCESS](state, payload) {
    state.search = {
      ...state.search,
      loading: false,
      error: false,
      giftVouchers: {
        items: [payload],
      },
    };
  },
  [C.GIFT_VOUCHER_SEARCH_GIFT_VOUCHERS_REFERENCE_FAILURE](state) {
    state.search = {
      ...state.search,
      loading: false,
      error: true,
    };
  },
  [C.GIFT_VOUCHER_SEARCH_CANCEL_SUCCESS](state, index) {
    state.search.giftVouchers.items[index].giftVoucher = {
      ...state.search.giftVouchers.items[index].giftVoucher,
      active: false,
      amountAvailable: 0,
    };
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/gift-vouchers/mutations.js